// extracted by css-extract-rspack-plugin
export default {"root":"ApplicationLayout_mobile_root__bkE95","logo":"ApplicationLayout_mobile_logo__kRtqb"};